// Utility for generating consistent search keys
import { djb2Hash } from './djb2Hash';

// age, residency and cur are intentionally excluded: they are stored in searchData
// and overwritten on re-search, so variants of the same trip share one recent-search entry.
export const getSearchKey = (params) => {
  const { startDate, endDate, fromLocationCode, toLocationCode } = params || {};
  return djb2Hash([
    startDate || '',
    endDate || '',
    fromLocationCode || '',
    toLocationCode || ''
  ].join('|')).toString();
};